export default __webpack_public_path__ + "static/media/misc-closetA-768w.03a2c3e0.png";